// Тип заявки
export const SUBJECT_TYPES = {
  // Урок
  lesson: 1,
  // Тема
  unit: 2,
  // Курс
  course: 3,
};

export const SUBJECT_TYPES_NAMES = {
  1: 'Урок',
  2: 'Тема',
  3: 'Курс',
};

export const SUBJECT_TYPES_FILTERS = {
  1: 'only_lessons',
  2: 'only_course_units',
  3: 'only_courses',
};

export const SUBJECT_TYPES_ITEMS = {
  [SUBJECT_TYPES.lesson]: {
    value: SUBJECT_TYPES.lesson,
    name: SUBJECT_TYPES_NAMES[SUBJECT_TYPES.lesson],
  },
  [SUBJECT_TYPES.unit]: {
    value: SUBJECT_TYPES.unit,
    name: SUBJECT_TYPES_NAMES[SUBJECT_TYPES.unit],
  },
  [SUBJECT_TYPES.course]: {
    value: SUBJECT_TYPES.course,
    name: SUBJECT_TYPES_NAMES[SUBJECT_TYPES.course],
  },
};

// Вид заявки
export const TYPES = {
  // Консультация
  consultation: 1,
  // Проверка задания
  taskCheck: 2,
};

export const TYPES_NAMES = {
  1: 'Консультации',
  2: 'Задания',
};

export const TYPES_ITEMS = {
  0: {
    value: null,
    name: 'Все',
  },
  [TYPES.consultation]: {
    value: TYPES.consultation,
    name: TYPES_NAMES[TYPES.consultation],
  },
  [TYPES.taskCheck]: {
    value: TYPES.taskCheck,
    name: TYPES_NAMES[TYPES.taskCheck],
  },
};

export const INITIAL_PAGINATION = {
  [SUBJECT_TYPES.lesson]: {
    consult: {
      pages: 1,
    },
    journal: {
      pages: 1,
    },
    page: 1,
    pages: 0,
    total: null,
  },
  [SUBJECT_TYPES.unit]: {
    consult: {
      pages: 1,
    },
    journal: {
      pages: 1,
    },
    page: 1,
    pages: 0,
    total: null,
  },
  [SUBJECT_TYPES.course]: {
    consult: {
      pages: 1,
    },
    journal: {
      pages: 1,
    },
    page: 1,
    pages: 1,
    total: null,
  },
};
